import { Grid, GridProps } from '@mui/material';

export const SmallGridItem = (props: GridProps) => (
    <Grid
        size={{
            xs: 12,
            sm: 6,
            md: 4,
            xl: 3,
        }}
        {...props}
    />
);
